(function () {
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function geocode(address, token) {
    var url =
      'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
      encodeURIComponent(address) +
      '.json?limit=1&access_token=' +
      token;

    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var feature = data && data.features && data.features[0];
        return feature ? feature.center : null; // [lng, lat]
      })
      .catch(function () {
        return null;
      });
  }

  function resolveStore(store, token) {
    var lat = parseFloat(store.lat);
    var lng = parseFloat(store.lng);

    if (!isNaN(lat) && !isNaN(lng)) {
      return Promise.resolve({ name: store.name, address: store.address, ctaLink: store.ctaLink, lat: lat, lng: lng });
    }

    if (!store.address) return Promise.resolve(null);

    return geocode(store.address, token).then(function (center) {
      if (!center) return null;
      return { name: store.name, address: store.address, ctaLink: store.ctaLink, lng: center[0], lat: center[1] };
    });
  }

  function initMap(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var token = container.dataset.mapboxToken;
    var zoom = parseFloat(container.dataset.zoom) || 14;
    var fitBounds = container.dataset.fitBounds === 'true';

    var stores;
    try {
      stores = JSON.parse(container.dataset.stores) || [];
    } catch (e) {
      stores = [];
    }
    stores = stores.filter(function (s) {
      return s && (s.address || (s.lat && s.lng));
    });
    if (!stores.length) return;

    mapboxgl.accessToken = token;

    Promise.all(
      stores.map(function (s) {
        return resolveStore(s, token);
      })
    ).then(function (resolved) {
      resolved = resolved.filter(Boolean);
      if (!resolved.length) return;

      var first = resolved[0];
      var map = new mapboxgl.Map({
        container: container,
        style: 'mapbox://styles/mapbox/dark-v11',
        center: [first.lng, first.lat],
        zoom: zoom
      });

      map.addControl(new mapboxgl.NavigationControl(), 'top-right');

      var bounds = new mapboxgl.LngLatBounds();

      resolved.forEach(function (s, index) {
        var popupHtml =
          '<strong>' + escapeHtml(s.name || '') + '</strong>' +
          (s.address ? '<br>' + escapeHtml(s.address) : '') +
          (s.ctaLink
            ? '<br><a class="store-map-cta" href="' +
              escapeHtml(s.ctaLink) +
              '" target="_blank" rel="noopener">SHOP NOW</a>'
            : '');

        var popup = new mapboxgl.Popup({ offset: 24, closeOnClick: false, className: 'store-map-popup' }).setHTML(
          popupHtml
        );

        var marker = new mapboxgl.Marker().setLngLat([s.lng, s.lat]).setPopup(popup).addTo(map);

        // The default location (first store) starts with its popup open.
        if (index === 0) marker.togglePopup();

        bounds.extend([s.lng, s.lat]);
      });

      if (fitBounds && resolved.length > 1) {
        map.fitBounds(bounds, { padding: 48, maxZoom: zoom });
      }
    });
  }

  function init() {
    document.querySelectorAll('.store-map[data-mapbox-token]').forEach(initMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
